var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project)?_c('div',{staticClass:"tile is-child project-card card",style:({ 'background-image': 'url(' + _vm.project.bg + ')' })},[_c('div',{staticClass:"card-content"},[_c('h2',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.project.title))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }